import React from "react"
import classes from "./Handbook.module.scss"
import TransitionContainer from "../../generic/wrappers/TransitionContainer"

interface IBlock {
  title: string
  block: any
}

interface IHandbookProps {
  blocks: IBlock[]
}

export default function Handbook({blocks}: IHandbookProps) {
  return (
    <div className={classes.wrap}>
      <TransitionContainer className={classes.tabs} blocks={blocks} withTitleBorder={true}/>
    </div>
  )
}